import BaseAPI from '../base'

function getChains() {
    return BaseAPI.get(`chain/list`);
}

function createChain(data) {
    return BaseAPI.post(`chain/create`, data);
}

function updateChain(id, data) {
    return BaseAPI.post(`chain/update/${id}`, data);
}

function centralMenusChanged(chain_id, value, cafe_id) {
    return BaseAPI.post(`chain/central_menus_changed`, {
        chain_id,
        is_enabled: value,
        cafe_id
    });
}

export default {
    getChains,
    createChain,
    updateChain,
    centralMenusChanged
}